<app-layout [hidden]="!loaded || error"></app-layout>
<div [hidden]="!loaded || !error" class="error-page">
  <h1>Something went Wrong!</h1>
  <button (click)="reload()">Refresh</button>
</div>
<div style="margin: 50px auto; width: 80%" [hidden]="loaded"><mat-progress-bar mode="query"></mat-progress-bar></div>
